import api, { request } from '../../../../api';
import { IInvitationStore } from '../store';

import { IErrorsStore } from '../../../errors/store';
import { IStore } from '../../../index';
import { TOmitFirstArg } from '../../../Interfaces/OmitFirstArg';

type TGetInvitationActionWithState = (
  state: IStore,
  invitationCode: string
) => Promise<{ invitation: IInvitationStore; error: IErrorsStore }>;

export const get = async (state: IStore, invitationCode: string) => {
  if (state.invitation.code === invitationCode) {
    return { invitation: state.invitation };
  }
  const response = await request.get(`${api.invitations}${invitationCode}`);

  if (response.error) {
    return {
      errors: { ...state.errors, invitation: { msg: 'Error checking the invitation code' } }
    };
  }

  return { invitation: { ...response, code: invitationCode } };
};

export type TGetInvitationAction = TOmitFirstArg<TGetInvitationActionWithState>;
